import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW2000Component } from './kymw2000.component';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { GetCycleMediumListService } from './api-services/get-cycle-medium-list.service'
import { GetCycleTempSelectedSummaryService } from './api-services/get-cycle-temp-selected-summary.service'
import { GetCycleTempSelectedSummaryByBuyerService } from './api-services/get-cycle-temp-selected-summary-by-buyer.service'
import { GetCycleOrderNumQuotaSelectedSummaryService } from './api-services/get-cycle-order-num-quota-selected-summary.service'
import { OutputCycleOrderNumQuotaSelectedSummaryService } from './api-services/output-cycle-order-num-quota-selected-summary.service'
import { GetPlanTempSelectedSummaryService } from './api-services/get-plan-temp-selected-summary.service'
import { GetPlanTempSelectedSummaryByBuyerService } from './api-services/get-plan-temp-selected-summary-by-buyer.service'
import { GetPlanOrderNumQuotaSelectedSummaryService } from './api-services/get-plan-order-num-quota-selected-summary.service'
import { OutputPlanOrderNumQuotaSelectedSummaryService } from './api-services/output-plan-order-num-quota-selected-summary.service'

/**
 * 選定済商品数一覧 モジュール設定クラス
 *
 * @export KYMW2000Module
 * @class KYMW2000Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjGridFilterModule,
  ],
  declarations: [
    KYMW2000Component,
  ],
  providers: [
    GetCycleMediumListService,
    GetCycleTempSelectedSummaryService,
    GetCycleTempSelectedSummaryByBuyerService,
    GetCycleOrderNumQuotaSelectedSummaryService,
    OutputCycleOrderNumQuotaSelectedSummaryService,
    GetPlanTempSelectedSummaryService,
    GetPlanTempSelectedSummaryByBuyerService,
    GetPlanOrderNumQuotaSelectedSummaryService,
    OutputPlanOrderNumQuotaSelectedSummaryService,
  ],
})
export class KYMW2000Module {

}
